module.exports = __webpack_public_path__ + "img/knowledgefoundry.f27a911b.png";